import React, { ChangeEvent } from 'react';

import { isEmptyNullOrUndefined } from 'flow/utils';
import { TypedMap } from 'flow/types/TypedMap';
import { Calendar } from 'flow/types/Calendar';
import useAppContext from 'flow/hooks/useAppContext';
import SettingsBlock from '../settings/SettingsBlock';
import InfoBox, { InfoBoxType } from '../ui-components/InfoBox';
import SettingRow from '../Setting/SettingRow';
import Button from '../ui-components/Button';
import InputField from '../ui-components/InputField';

interface Props {
    calendar: TypedMap<Calendar>;
    updateCalendar: (calendarEvent: object) => void;
    clearCalendar: () => void;
}

const CalendarExternalURL = ({
    calendar,
    updateCalendar,
    clearCalendar,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <>
            <SettingsBlock>
                <InputField
                    defaultValue={calendar.get('url')}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        if (!isEmptyNullOrUndefined(event.target)) {
                            const updatedCalendar = calendar.set(
                                'url',
                                event.target.value,
                            );
                            updateCalendar(updatedCalendar);
                        }
                    }}
                />
            </SettingsBlock>

            <SettingRow childrenClassName="text-xs text-gray-500">
                {i18next.t('calendar.other.external.url.help')}
            </SettingRow>

            <InfoBox type={InfoBoxType.Info} className="text-xs">
                {i18next.t('calendar.other.external.url.obs')}
            </InfoBox>

            <SettingsBlock className="py-2">
                <Button
                    type="button"
                    onClick={clearCalendar}
                    disabled={!calendar.has('url')}
                >
                    {i18next.t('remove')}
                </Button>
            </SettingsBlock>
        </>
    );
};

export default CalendarExternalURL;
